import {getUsnoImage} from '@/api/utils/usno-image'
import {getPanstarrsImage} from '@/api/utils/panstarrs-image'

// Getters are computed properties for stores. Like computed properties, a getter's
// result is cached based on its dependencies, and will only re-evaluate when some
// of its dependencies have changed.
// Read more: https://vuex.vuejs.org/guide/getters.html
export default {
  img1: ({candidate}) => getUsnoImage(candidate.item.imageKey, candidate.item.usnoBand),
  img2: ({candidate}) => getPanstarrsImage(candidate.item.imageKey, candidate.item.panstarrBand)
}
